import { render, staticRenderFns } from "./MediaInfo.vue?vue&type=template&id=58fb99d0&scoped=true&"
import script from "./MediaInfo.vue?vue&type=script&lang=js&"
export * from "./MediaInfo.vue?vue&type=script&lang=js&"
import style0 from "./MediaInfo.vue?vue&type=style&index=0&id=58fb99d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb99d0",
  null
  
)

export default component.exports